module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Regular-Alphabetic.ac8c4d83.woff";